// extracted by mini-css-extract-plugin
export default {"word":"Transcript_word__HXNSs","active-word":"Transcript_active-word__KQd1E"};